import { faChainBroken, faCheckCircle, faUnlink } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';

const LogCard = ({ log }) => {
  const [isOpen, setIsOpen] = useState(false);

  
  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  

  return (
    <div
      onClick={toggleOpen}
      className={`cursor-pointer p-6 dark:bg-gray-800 bg-white shadow-md rounded-lg transition-transform duration-300 ease-in-out 
        transform hover:scale-105 hover:shadow-lg ${isOpen ? 'mb-6' : 'mb-3'}`}
    >
      <div className="flex items-center justify-between">
        <div className="flex flex-row items-center gap-5">
          <span
            className={`px-3 py-1 rounded-full text-sm font-medium ${
              log.success ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'
            }`}
          >
            {log.success ? 
              (<FontAwesomeIcon icon={faCheckCircle} className='text-green-600'/>)
              :
              (<FontAwesomeIcon icon={faUnlink} className='text-red-600'/>)
            }
          </span>
          <h3 className="text-lg font-semibold dark:text-gray-200">{log.action}</h3>
        </div>
        
        <span
          className={`transform transition-transform duration-300 dark:text-gray-200 ${
            isOpen ? 'rotate-180' : 'rotate-0'
          }`}
        >
          ▼
        </span>
      </div>

      {/* Section résumée */}
      {isOpen && (
        <>  
          <div className="flex items-center justify-between mt-2 text-gray-500">
            <span className="text-sm">{new Date(log.createdAt).toLocaleDateString()}, {new Date(log.createdAt).toLocaleTimeString()}</span>
            
            <span className="text-sm font-medium text-gray-700">{log.responsible}</span>
          </div>
        
          <div className="mt-4 text-gray-600 transition-all duration-500">
            <p className='dark:text-gray-200'>{log.details}</p>
          </div>
        </>
      )}
    </div>

  );
};

export default LogCard;